"use client";
import { jsx } from "react/jsx-runtime";
import { RadioGroup } from "@base-ui/react/radio-group";
import { useCallback } from "react";
import { cn } from "../../../utils/index.js";
import { RadioWithLabel } from "../RadioWithLabel/RadioWithLabel.js";
import { radioGroupVariants } from "./RadioGroup.variants.js";
function RadioGroup_RadioGroup({ name, defaultValue, handleChange, className = '', options, disabled, required, layout, ...props }) {
    const { radioGroup } = radioGroupVariants({
        layout
    });
    const onValueChange = useCallback((value, eventDetails)=>{
        handleChange(value, eventDetails?.event);
    }, [
        handleChange
    ]);
    const classes = cn(radioGroup(), className);
    return /*#__PURE__*/ jsx(RadioGroup, {
        disabled: disabled,
        name: name,
        defaultValue: defaultValue,
        onValueChange: onValueChange,
        className: classes,
        required: required,
        ...props,
        children: options.map((option)=>/*#__PURE__*/ jsx(RadioWithLabel, {
                ...option,
                disabled: disabled ?? option.disabled,
                value: String(option.value),
                layout: layout,
                isRadioGroup: true
            }, option.value))
    });
}
export { RadioGroup_RadioGroup as RadioGroup };
